import { hideSetPasswordModal, setPasswordSubmit } from '../../../actions/userActions';
import { modalRootClassName } from '../../../utils/modalRootClassName';
import Messages from '../Messages';
import { useEffect } from 'react';
import { Field, Form } from 'react-final-form';
import { connect } from 'react-redux';

// Validation function
const createValidate = (passwordResetPending) => (values) => {
  const errors = {};
  if (!passwordResetPending && !values.current_password) {
    errors.current_password = 'Current Password is required.';
  }
  if (!values.reset_password) {
    errors.reset_password = 'Password is required.';
  }
  if (!values.confirm_password) {
    errors.confirm_password = 'Confirm password is required.';
  }
  if (values.reset_password && values.confirm_password && values.reset_password !== values.confirm_password) {
    errors.confirm_password = 'Passwords must match.';
  }
  return errors;
};

const SetPasswordForm = ({ content, user, showModal, showCloseButton, hideSetPasswordModal, setPasswordSubmit }) => {
  useEffect(() => {
    if (!showModal) {
      return undefined;
    }
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prevOverflow;
    };
  }, [showModal]);

  useEffect(() => {
    if (!showModal) {
      return undefined;
    }
    const onKeyDown = (e) => {
      if (e.key === 'Escape') {
        hideSetPasswordModal();
      }
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [showModal, hideSetPasswordModal]);

  if (!showModal) {
    return null;
  }

  const action = user.details?.passwordResetPending ? 'Set' : 'Change';
  const currentLabel = user.details?.passwordResetPending ? 'Current password' : 'Current password';
  const passwordLabel = user.details?.passwordResetPending ? 'Password' : 'New password';
  const confirmLabel = user.details?.passwordResetPending ? 'Confirm password' : 'Confirm new password';
  const passwordResetPending = user.details?.passwordResetPending || false;
  const validate = createValidate(passwordResetPending);

  const modalClassName = modalRootClassName(true, { staticBackdrop: true });

  return (
    <>
      <div className="modal-backdrop fade show" aria-hidden="true" />
      <div
        className={modalClassName}
        tabIndex="-1"
        role="dialog"
        id="setPasswordModal"
        aria-labelledby="setPasswordModalLabel"
        aria-modal="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <Form
              onSubmit={setPasswordSubmit}
              validate={validate}
              initialValues={{ sessionId: user.sessionId }}
              render={({ handleSubmit, submitting }) => (
                <form onSubmit={handleSubmit}>
                  <Field name="sessionId" component="input" type="hidden" />
                  <div className="modal-header">
                    <h4 className="modal-title" id="setPasswordModalLabel">
                      {action} your password
                    </h4>
                  </div>
                  <div className="modal-body bg-light-grey">
                    <Messages filter="setpassword" />
                    {content.intro && !showCloseButton ? <p>{content.intro}</p> : ''}
                    {!passwordResetPending && <PasswordField name="current_password" label={currentLabel} />}
                    <PasswordField name="reset_password" label={passwordLabel} />
                    <PasswordField name="confirm_password" label={confirmLabel} />
                  </div>
                  <div className="modal-footer">
                    <div className="Actions">
                      <button className="action btn btn-primary" type="submit" disabled={submitting}>
                        {submitting ? 'Saving...' : `${action} your password`}
                      </button>
                      {showCloseButton && (
                        <button className="btn btn-default" onClick={hideSetPasswordModal} type="button">
                          Close
                        </button>
                      )}
                    </div>
                  </div>
                </form>
              )}
            />
          </div>
        </div>
      </div>
    </>
  );
};

const PasswordField = ({ name, label }) => (
  <Field name={name}>
    {({ input, meta }) => (
      <div className={`form-group${meta.touched && meta.error ? ' error' : ''}`}>
        <label className="control-label" htmlFor={name}>
          {label}
        </label>
        <input {...input} id={name} className="form-control password" type="password" />
        {meta.touched && meta.error && <div className="text-danger">{meta.error}</div>}
      </div>
    )}
  </Field>
);

const mapStateToProps = (state) => ({
  user: state.user,
  showModal: state.auth.showSetPasswordModal,
  showCloseButton: state.auth.showSetPasswordCloseButton,
  content: state.config.content.setPassword,
});

const mapDispatchToProps = {
  setPasswordSubmit,
  hideSetPasswordModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(SetPasswordForm);
